<template>
  <div class="rule-manage-box">
    <div class="title">规则管理</div>
    <a-input v-model:value="inputValue" placeholder="客户区域、业务参数搜索" @change="handleChange" class="search-input">
    <template #prefix>
        <SearchOutlined />
      </template>
    </a-input>
    <div class="manage-msg" @click="handleClick(item)" :class="selectBtn == item.Value ? 'select' : ''" v-for="(item,index) in useList" :key="index">
      {{item.Text}}
    </div>

  </div>
</template>

<script lang="ts">
import { defineComponent, ref, PropType, toRefs, watch } from 'vue'
import type{ IndexEchart } from '@/types/index'
import { SearchOutlined } from '@ant-design/icons-vue'
export default defineComponent({
  props: {
    listData: {
      type: Array as PropType<IndexEchart.ServiceParamSetting[]>
    }
  },
  components: { SearchOutlined },
  setup(props, { emit, attrs }) {
    console.log('attrs: ', attrs)
    console.log('emit: ', emit)
    const list:any = toRefs(props).listData
    const useList = ref<IndexEchart.ServiceParamSetting[]>()
    useList.value = list.value

    watch(props, (newValue) => {
      useList.value = newValue.listData
    })
    const inputValue = ref('')
    const selectBtn = ref<string>()
    if (list.value && list.value.length > 0) {
      emit('selectTag', list.value[0])
      selectBtn.value = list.value[0].Value
    }
    watch(useList, (newValue) => {
      if (newValue && newValue?.length > 0) {
        emit('selectTag', list.value[0])
        selectBtn.value = list.value[0].Value
      }
    })
    const handleClick = (data:IndexEchart.ServiceParamSetting) => {
      selectBtn.value = data.Value
      emit('selectTag', data)
    }
    const handleChange = () => {
      useList.value = list.value.filter((item:any) => {
        return item.Text.indexOf(inputValue.value) !== -1
      })
    }
    return {
      selectBtn,
      list,
      handleClick,
      inputValue,
      handleChange,
      useList
    }
  }
})
</script>
<style lang="scss" scoped>
.rule-manage-box {
  padding: 16px;
  .title {
    font-weight: 500;
    font-size: 16px;
    color: #132043;
    padding-left: 8px;
    position: relative;
    margin-bottom: 12px;
  }
  .title::after {
    width: 2px;
    height: 20px;
    background-color: #1d4cd2;
    position: absolute;
    left: 0;
    top: 3px;
    content: '';
  }

  .manage-msg {
    width: 100%;
    height: 36px;
    border-bottom: 1px solid rgb(235, 239, 241);
    font-weight: 400;
    font-size: 14px;
    color: #000000;
    padding-left: 8px;
    box-sizing: border-box;
    display: flex;
    align-items: center;
    margin-bottom: 12px;
    cursor: pointer;
    transition: 0.5s background-color ease;
    border-radius: 4px 0px 0px 4px;
    overflow: hidden;
  }
  .select {
    background: #1d4cd2;
    border-radius: 4px 0px 0px 4px;
    border-bottom: 1px solid rgb(235, 239, 241);
    color: #fff;
    overflow: hidden;

  }
  .search-input{
    margin-bottom: 8px;
  }
}
</style>
